export default function syncRowHeights() {
  const tables = document.querySelectorAll('.sync');
  var rowCount = 0;
  tables.forEach((table) => {
    if (table.rows.length > rowCount) {
      rowCount = table.rows.length
    }
  })
  const maxHeights = Array(rowCount).fill(0);

  tables.forEach((table) => {
    for (let rowIndex = 0; rowIndex < rowCount; rowIndex++) {
      const row = table.rows[rowIndex];
      if (!row) return
      if (row.style) {
        row.style.height=0;
      }
      let maxHeightForRow = 0;

      for (const cell of row.cells) {
        const contentHeight = cell.offsetHeight;
        if (cell.querySelector('textarea')) {
          const textareaHeight = cell.querySelector('textarea').scrollHeight;
          maxHeightForRow = Math.max(maxHeightForRow, contentHeight, textareaHeight);
        } else {
          maxHeightForRow = Math.max(maxHeightForRow, contentHeight);
        }
      }

      maxHeights[rowIndex] = Math.max(maxHeights[rowIndex], maxHeightForRow);
    }
  });

  tables.forEach((table) => {
    for (let rowIndex = 0; rowIndex < rowCount; rowIndex++) {
      if (table.rows[rowIndex] && table.rows[rowIndex].style) {
        table.rows[rowIndex].style.height = `${maxHeights[rowIndex]}px`;
      }
    }
  });
};